"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointDetailNew = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var MyPointDetailNew = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyPointDetailNew, _super);
    function MyPointDetailNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '新积分详情接口';
        _this.code = '101163';
        _this.desc = '积分详情接口（支持分页与积分类型）';
        _this.requestParams = new point_1.MyPointDetailNewRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyPointDetailNew;
}(service_1.BaseService));
exports.MyPointDetailNew = MyPointDetailNew;
//# sourceMappingURL=myPointDetailNew.js.map